import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	icon: {
		marginTop: -2,
	},
});
